import React, { useState } from "react";
import { useEffect } from "react";
import AOS from "aos";
import Modal from "react-bootstrap/Modal";
import "aos/dist/aos.css";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import Alert from "../assets/img/alert.png";
import { Container, Col, Row, Image } from "react-bootstrap";
import timg1 from "../assets/img/timage1.jpg";
import timg2 from "../assets/img/timage2.jpg";
import timg3 from "../assets/img/timage3.jpg";
import timg4 from "../assets/img/timage4.jpg";
import timg5 from "../assets/img/timage5.jpg";
import timg6 from "../assets/img/timage6.jpg";
import timg7 from "../assets/img/timage7.jpg";
import timg8 from "../assets/img/timage8.jpg";
import timg9 from "../assets/img/timage9.jpg";
import timg10 from "../assets/img/timage10.jpg";
import timg11 from "../assets/img/timage11.jpg";
import deleteicon from "../assets/img/delete.png";
import axios from "axios";
import Cookies from "js-cookie";
import "./Tournament.css";
import { useNavigate } from "react-router-dom";
import Toast from "react-bootstrap/Toast";
import ToastContainer from "react-bootstrap/ToastContainer";

export default function TournamentCards() {
  const [tournaments, setTournaments] = useState([]);
  const [isLoggedIn, setIsLoggenIn] = useState(false);
  const [todeleteId, setTodeleteId] = useState("");
  const [show, setShow] = useState(false);
  const [showDeleteSuccess, setShowDeleteSuccess] = useState(false);
  const [showDeleteFail, setShowDeleteFail] = useState(false);
  const [loader, setLoader] = useState(false);

  const toggleShowDeleteSuccess = () =>
    setShowDeleteSuccess(!showDeleteSuccess);
  const toggleShowDeleteFail = () => setShowDeleteFail(!showDeleteFail);

  const handleClose = () => setShow(false);
  const handleShow = (id) => {
    // console.log(id);
    setTodeleteId(id);
    setShow(true);
  };

  async function deleteTournament(id) {
    let token = Cookies.get("token");

    await axios
      .delete(
        `https://vickygaming.onrender.com/api/v1/tournaments/${todeleteId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((response) => {
        // console.log(response);
        setTodeleteId("");
        handleClose();
        toggleShowDeleteSuccess();
        getTournaments();
      })
      .catch((error) => {
        toggleShowDeleteFail();
        console.log(error);
        // if (error.response.data.message === "'Incorrect password or email") {
        //   toggleShowDeleteSuccess();
        // }
      });
  }
  useEffect(() => {
    setLoader(true);
    const token = Cookies.get("token");

    if (token) {
      setIsLoggenIn(true);
    } else {
      setIsLoggenIn(false);
    }
    AOS.init();

    getTournaments();
  }, []);
  const navigate = useNavigate();
  let array = [
    timg1,
    timg2,
    timg3,
    timg4,
    timg5,
    timg6,
    timg7,
    timg8,
    timg9,
    timg10,
    timg11,
  ];
  async function getTournaments() {
    await axios
      .get(`https://vickygaming.onrender.com/api/v1/tournaments`, {
        returnSecureToken: true,
      })
      .then((response) => {
        setTournaments(response.data.data.tournaments);
        setLoader(false);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  function handleDate(date) {
    const d = new Date(date);
    return d.getDate();
  }
  function handleMonth(date) {
    const d = new Date(date);
    // const month = date.toLocaleString('default', { month: 'long' });
    return d.toLocaleString("default", { month: "long" });
  }
  function handleYear(date) {
    const d = new Date(date);
    return d.getFullYear();
  }

  return (
    <section>
      <ToastContainer
        position="bottom-end"
        className="p-3"
        style={{ zIndex: 1 }}
      >
        <Toast
          show={showDeleteFail}
          onClose={toggleShowDeleteFail}
          delay={3000}
          autohide
          bg="danger"
        >
          <Toast.Body>Something went wrong! Please try again later.</Toast.Body>
        </Toast>
      </ToastContainer>

      <ToastContainer
        position="bottom-end"
        className="p-3"
        style={{ zIndex: 1 }}
      >
        <Toast
          show={showDeleteSuccess}
          onClose={toggleShowDeleteSuccess}
          delay={3000}
          autohide
          bg="success"
        >
          <Toast.Body>Successfully Deleted!</Toast.Body>
        </Toast>
      </ToastContainer>

      <Modal show={show} onHide={handleClose} className="mt-5">
        <Modal.Header
          style={{
            background: "rgb(34, 34, 34)",
            color: "#fff",
            borderBottom: "1px solid black",
          }}
        >
          <Modal.Title>
            {" "}
            <span>
              <Image
                src={Alert}
                alt="alerticon"
                style={{ width: "30px", height: "30px", margin: "0px" }}
              />{" "}
            </span>{" "}
            Alert
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            background: "rgb(34, 34, 34)",
            color: "#fff",
          }}
        >
          Are You sure want to delete?
        </Modal.Body>
        <Modal.Footer
          style={{
            background: "rgb(34, 34, 34)",
            color: "#fff",
            borderTop: "1px solid black",
          }}
        >
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="danger" onClick={() => deleteTournament(todeleteId)}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
      <Container>
        <div className="align-items-center text-center mt-4 mb-4">
          <h2
            style={{ fontSize: "28px" }}
            data-aos="fade-up-right"
            className="tbtn"
          >
            Tournaments
          </h2>
        </div>
        {isLoggedIn && (
          <div className="addbutton  mt-5" style={{ marginBottom: "-50px" }}>
            <Button
              className="tbutton mt-4"
              onClick={() => navigate("/addTournament")}
            >
              Add Tournament
            </Button>
          </div>
        )}
        {loader && (
          <div
            className="d-flex align-items-center justify-content-center text-center "
            style={{ marginTop: "90px" }}
          >
            {" "}
            <div className="wrapper">
              <div className="circle"></div>
              <div className="circle"></div>
              <div className="circle"></div>
              <div className="shadow"></div>
              <div className="shadow"></div>
              <div className="shadow"></div>
            </div>
          </div>
        )}

        <div className="cards mb-4 mt-5">
          <Row xs={1} md={2} lg={3} className="g-4 mt-4">
            {tournaments.map((tournament, idx) => (
              <Col key={idx}>
                <Card
                  style={{ background: "rgb(34, 34, 34)", color: "#fff" }}
                  data-aos="zoom-in-up"
                >
                  <Card.Img
                    variant="top"
                    src={array[Math.floor(Math.random() * 11)]}
                  />
                  <Card.Body>
                    <Card.Title style={{ fontSize: "25px" }}>
                      {tournament.seasonName}
                    </Card.Title>
                    <div className="mt-4">
                      {handleDate(tournament.date)}{" "}
                      {handleMonth(tournament.date)}{" "}
                      {handleYear(tournament.date)}
                      <span style={{ color: "#f2f2f2" }}>|</span>{" "}
                      {tournament.time}
                      <br />
                      <div className="row ">
                        <div className="col-6">
                          <Button
                            className="mt-3 tbutton"
                            onClick={() =>
                              navigate(`/tournament/${tournament._id}`)
                            }
                          >
                            Know more
                          </Button>
                        </div>
                        {isLoggedIn && (
                          <div
                            className="col-6"
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                              cursor: "pointer",
                            }}
                          >
                            <Image
                              src={deleteicon}
                              alt="deleteicon"
                              className="mt-4"
                              style={{ width: "30px", height: "30px" }}
                              onClick={() => handleShow(tournament._id)}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
      </Container>
    </section>
  );
}
